<template>
  <div>
    <!-- Grading Radio Buttons -->
    <div v-if="(userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11118')" class="manual-grading mt-3 mb-3">
      <label class="mr-3">
        <input
          type="radio"
          :name="'grade-' + propQueData.qbk_id"
          :value="1"
          v-model.number="answerResult"
          @change="handleCorrect"
        >
        <span class="text-success ml-1">Correct</span>
      </label>
      <label>
        <input
          type="radio"
          :name="'grade-' + propQueData.qbk_id"
          :value="0"
          v-model.number="answerResult"
          @change="handleIncorrect"
        >
        <span class="text-danger ml-1">Incorrect</span>
      </label>
    </div>

    <b-modal
      v-model="showModal"
      title="Grade Question"
      size="md"
      @hidden="resetModal"
    >
      <!-- Header Note -->
      <div class="alert alert-primary" role="alert">
        <small>
          <strong>Note:</strong> Enter the score obtained by the student for this question.
          <br/>
          <span class="text-secondary">Maximum score: {{ propMaxScore }} points</span>
        </small>
      </div>

      <!-- Question Info -->
      <div class="mb-3">
        <h6 class="mb-3"><strong>Question ID:</strong> <span class="text-secondary">{{ propQueData.qbk_id }}</span></h6>
        <h6><strong>Student Answer: <span class="text-secondary">{{ studentAnswer }}</span></strong></h6>
      </div>

      <!-- Score Input -->
      <div class="form-group mb-3">
        <label for="scoreInput" class="h6 font-weight-bold">Score:</label>
        <div class="input-group">
          <input
            id="scoreInput"
            v-model.number="answer_score"
            type="number"
            class="form-control"
            :min="0"
            :max="propMaxScore"
            :step="1"
            placeholder="Enter score"
            autofocus
          />
          <div class="input-group-append">
            <span class="input-group-text">/ {{ propMaxScore }}</span>
          </div>
        </div>
        <small class="form-text text-muted">
          Enter a value between 1 and {{ propMaxScore }}
        </small>
      </div>

      <!-- Error Message -->
      <div v-if="errorMsg" class="alert alert-danger" role="alert">
        {{ errorMsg }}
      </div>

      <!-- Modal Footer -->
      <template #modal-footer="">
        <b-button size="sm" @click="closeModal">
          Cancel
        </b-button>
        <b-button size="sm" variant="primary" @click="submitScore">
          <span v-if="isLoading">
            <b-spinner small class="mr-2"></b-spinner>
            Saving...
          </span>
          <span v-else>Save Score</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { QuizAnswers } from "../../../FackApi/api/quizAnswers.js"

export default {
  name: "QuestionScoringModal",
  props: {
    propQueData: {
      type: Object,
      default: () => ({})
    },
    propQuestionBankObj: {
      type: Object,
      default: () => ({})
    },
    propMaxScore: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      showModal: false,
      answer_score: 1,
      answerResult: null,
      isLoading: false,
      errorMsg: ""
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    },
    studentAnswer () {
      if (this.propQueData.is_mcq === 1) {
        return this.propQuestionBankObj.user_response === "z" ? "Unattempted" : this.propQuestionBankObj.user_response
      }
      return this.propQueData.answer === "z" ? "Unattempted" : this.propQueData.answer
    }
  },
  mounted () {
    if (this.propQueData.answer_result !== undefined && this.propQueData.answer_result !== null) {
      this.answerResult = Number(this.propQueData.answer_result)
    }

    if (this.propQueData.answer_score !== undefined && this.propQueData.answer_score !== null) {
      this.answer_score = this.propQueData.answer_score
    }
    else {
      this.answer_score = 1
    }
  },
  methods: {
    /**
     * handleCorrect
     */
    handleCorrect () {
      if ((!this.propQueData.image || this.propQueData.is_mcq == 1) && this.propQueData.answer === "z") {
        this.$emit("emitScoreSubmitted", {
          success: false,
          message: this.propQueData.is_mcq === 1
            ? "No answer provided. This question is unattempted and cannot be marked as correct."
            : "No answer image or response provided. This question is unattempted and cannot be marked as correct.",
          data: null
        })
        this.$nextTick(() => {
          this.answerResult = 0
        })
        return
      }

      this.answer_score = 1
      this.showModal = true
    },
    /**
     * handleIncorrect
     */
    async handleIncorrect () {
      try {
        this.isLoading = true

        let baseAnswer = ""
        if (this.propQueData.is_mcq === 1) {
          baseAnswer = this.propQuestionBankObj.user_response ? this.propQuestionBankObj.user_response : ""
        }
        else {
          baseAnswer = this.propQueData.answer ? this.propQueData.answer : ""
        }

        if (baseAnswer.includes("#incorrect#")) {
          baseAnswer = baseAnswer.split("#incorrect#")[0]
        }

        const incorrectAnswerPayload = `${baseAnswer}#incorrect#`
        const payload = {
          user_id: this.propQuestionBankObj.user_id,
          aprs_id: this.propQuestionBankObj.aprs_id ? this.propQuestionBankObj.aprs_id : null,
          qbk_id: this.propQueData.qbk_id,
          answer: incorrectAnswerPayload,
          answer_result: 0,
          answer_score: 0,
          app_id: this.propQueData.app_id
        }

        const response = await QuizAnswers.quizAnswersupdate(this, payload)
        if (response && response.resp_status) {
          this.$emit("emitScoreSubmitted", {
            success: true,
            title: "Score Saved",
            message: `Score ${payload.answer_score} saved successfully and student answer updated`,
            data: payload
          })
        }
        else {
          this.errorMsg = response.resp_msg || "Error saving response"
          this.answerResult = null
        }
      }
      catch (error) {
        console.error("Error marking as incorrect:", error)
        this.answerResult = null
      }
      finally {
        this.isLoading = false
      }
    },
    /**
     * submitScore
     */
    async submitScore () {
      try {
        this.errorMsg = ""

        if (this.answer_score === null || this.answer_score === "") {
          this.errorMsg = "Please enter a score"
          return
        }

        if (this.answer_score <= 0 || this.answer_score > this.propMaxScore) {
          this.errorMsg = `Score must be greater than 0 and less than or equal to ${this.propMaxScore}`
          return
        }

        this.isLoading = true
        // Keep the shared app_quiz_bank correct answer unchanged. A manual
        // correct grade updates only this student's app_quiz_answers response.
        const correctAnswer = this.propQueData.correct_answers
        if (!correctAnswer) {
          this.errorMsg = "This question does not have a correct answer to save"
          return
        }

        const payload = {
          user_id: this.propQuestionBankObj.user_id,
          aprs_id: this.propQuestionBankObj.aprs_id ? this.propQuestionBankObj.aprs_id : null,
          qbk_id: this.propQueData.qbk_id,
          answer_result: 1,
          answer_score: this.answer_score,
          app_id: this.propQueData.app_id
        }

        const response = await QuizAnswers.quizAnswersupdate(this, payload)
        if (response && response.resp_status) {
          this.$emit("emitScoreSubmitted", {
            success: true,
            title: "Score Saved",
            message: `Score ${payload.answer_score} saved successfully and student answer updated`,
            data: payload
          })
          this.closeModal()
        }
        else {
          this.errorMsg = response.resp_msg || "Error saving score"
        }
      }
      catch (error) {
        console.error("Error submitting score:", error)
        this.errorMsg = "Error submitting score. Please try again."
      }
      finally {
        this.isLoading = false
      }
    },
    /**
     * closeModal
     */
    closeModal () {
      this.resetModal()
      this.showModal = false
    },
    /**
     * resetModal
     */
    resetModal () {
      this.answer_score = 1
      this.errorMsg = ""
    }
  },
  watch: {
    propQueData: {
      handler (newVal) {
        if (newVal.answer_result !== undefined && newVal.answer_result !== null) {
          this.answerResult = Number(newVal.answer_result)
        }
        else {
          this.answerResult = null
        }

        if (newVal.answer_score !== undefined && newVal.answer_score !== null) {
          this.answer_score = newVal.answer_score
        }
        else {
          this.answer_score = 1
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
.manual-grading {
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 5px;
  border-left: 4px solid #e5252c;

  label {
    font-weight: 500;
    margin-bottom: 0;
    cursor: pointer;
    display: inline-block;

    input[type="radio"] {
      margin-right: 6px;
      cursor: pointer;
    }

    span {
      cursor: pointer;
    }
  }
}

.alert {
  margin-bottom: 16px;
  border-radius: 4px;
}

.form-group {
  margin-bottom: 16px;

  label {
    margin-bottom: 8px;
    color: #333;
    display: block;
  }

  .input-group {
    input {
      border-radius: 4px 0 0 4px;
      border: 1px solid #ddd;

      &:focus {
        border-color: calc(var(--iq-primary) + 20%);
      }
    }

    .input-group-append {
      .input-group-text {
        background-color: #f8f9fa;
        border: 1px solid #ddd;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        font-weight: 600;
        color: #495057;
      }
    }
  }
}

.mb-3 {
  h6 {
    margin-bottom: 4px;
    font-size: 14px;
  }
}
</style>
